import React from "react"
import ReactDOM from "react-dom";

import  Meme  from "./Component/meme";

ReactDOM.render(  

    <Meme/>,
    document.getElementById('root')
)
